export const SHOW_RECOVERY_CONTRACT_MODAL_ACTION = 'app/RecoveryContractModal/SHOW_RECOVERY_CONTRACT_MODAL_ACTION';
export const HIDE_RECOVERY_CONTRACT_MODAL_ACTION = 'app/RecoveryContractModal/HIDE_RECOVERY_CONTRACT_MODAL_ACTION';
export const RECOVERY_ERROR_ACTION = 'app/RecoveryContractModal/RECOVERY_ERROR_ACTION';
export const RECOVERY_REQUIRES_NIF_ACTION = 'app/RecoveryContractModal/RECOVERY_REQUIRES_NIF_ACTION';
export const PRELOAD_DRAFT_ACTION = 'app/RecoveryContractModal/PRELOAD_DRAFT_ACTION';
export const LOAD_DRAFT_ACTION = 'app/RecoveryContractModal/LOAD_DRAFT_ACTION';
export const SET_LOADED_DRAFT_ACTION = 'app/RecoveryContractModal/SET_LOADED_DRAFT_ACTION';

